<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	<div class="mb-2">
			<el-form inline ref="form" :model="searchform">

				<el-form-item class="mb-0">
						 <el-select v-model="searchform.value2" :placeholder="$t('searchText.상태선택')"  size="mini" style="width:100px;">
						   <el-option
								      v-for="item in searchform.searchOptions2"
								      :key="item.value"
								      :label="item.label"
								      :value="item.value">
								    </el-option>
						  </el-select>
					</el-form-item>

					<el-form-item class="mb-0">
						 <el-select v-model="searchform.value" :placeholder="$t('searchText.타이틀선택')"  size="mini" style="width:100px;">
						   <el-option
								      v-for="item in searchform.searchOptions"
								      :key="item.value"
								      :label="item.label"
								      :value="item.value">
								    </el-option>
						  </el-select>
					</el-form-item>


					<el-form-item class="mb-0">
						 <el-input :placeholder="$t('searchText.키워드')"  v-model="searchform.keyword" size="mini" style="width:100px" ></el-input>
					</el-form-item>
					<el-form-item  class="mb-0" style="margin-right:0">
						 <el-date-picker
						      v-model="searchform.time"
						      type="daterange"
						      range-separator="~"
						      :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" size="mini" class="mr-2" value-format="yyyy-MM-dd" style="width:200px;">
						    </el-date-picker>
					</el-form-item>
					<el-form-item class="mb-0">
						<el-checkbox v-model="searchform.hide_del">삭제건안보기</el-checkbox>
					</el-form-item>
					<el-form-item class="mb-0" >
						<el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>	
					</el-form-item>
			</el-form>
       
		 
		
			
    		
		</div>
	<div class="d-flex align-items-center">
		  <el-input :placeholder="$t('searchText.구글OTP')" v-model="otp" size="mini" style="width: 100px;" class="mr-2"></el-input>
		<el-button type="danger" size="mini" @click="deleteAll">{{$t('searchText.선택삭제')}}</el-button>
		<el-button type="warning" size="mini" @click="restoreAll">선택복구</el-button>
		
	
	</div>

  <el-table
      :data="tableData"
       v-loading="loading"
      style="width: 100%"
      border class="mt-2" @selection-change="handleSelectionChange"   :empty-text="$t('tableText.데이타가없습니다')">
     <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
     <el-table-column width="50" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{total-(currentPage-1)*20-scope.$index}}</template>
        </el-table-column>
  <el-table-column
        v-if="this.userid=='admin'"
         :label="$t('msg.알본')"
         prop="admin_id" align="center" >
      </el-table-column>

      <el-table-column
        label="del"
        prop="del"
        align="center"
        width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.del !== null && scope.row.del !== undefined" class="qa-del-text">【삭제건】{{scope.row.del}}</span>
        </template>
      </el-table-column>

<el-table-column
        v-if="this.multi_site=='1'"
        label="사이트" prop="sitename" align="center" >
        
      </el-table-column> 
        

         <el-table-column
         :label="$t('nav.아이디')" prop="user_id" align="center" >
          <template slot-scope="scope">
            <div class="mem-id-cell" :style="{ backgroundColor: userid === 'soft16' ? (String(scope.row.memState) === '1' ? '#d1fae5' : String(scope.row.memState) === '4' ? '#dbeafe' : scope.row.RaceYN) : String(scope.row.memState) === '7' ? '#fff3cd' : String(scope.row.memState) === '6' ? '#e9d5ff' : (userid === 'soft23' && String(scope.row.memState) === '1') ? '#d1fae5' : scope.row.RaceYN }">
             <span @click="openIdModel(scope.row.user_id)" class="text-primary" style="cursor:pointer">{{scope.row.user_id}}</span>
           </div>
          </template>
      </el-table-column> 

      <el-table-column
        :label="$t('tableText.이름')" prop="mem_name" align="center" >
          <template slot-scope="scope">
            
             {{scope.row.mem_name}}({{ scope.row.memState>0 ? 'V'+scope.row.memState:level_title[scope.row.memState]}})
          </template>
      </el-table-column> 



     
      <el-table-column
        :label="$t('msg.문의제목')"
         prop="user_title" align="center">
        <template slot-scope="scope">{{scope.row.user_title}}<i class="ml-2 text-primary" :class="scope.row.mobile==='0' ? '':'el-icon-mobile'"></i></template>
      </el-table-column>
      <el-table-column
			prop="user_contents"
			:label="$t('msg.문의내용')"
			>
			 <template slot-scope="scope" >
            	<el-input
					  type="textarea"
					  :rows="2"
					  v-model="scope.row.user_contents">
					</el-input>
        	</template>
		  </el-table-column>
		    

		 

		   <el-table-column
        
        label="IP" prop="ip" align="center">
      </el-table-column>

		   <el-table-column
        :label="$t('msg.문의시간')"
        prop="add_time" align="center" >
      </el-table-column>

       <el-table-column
        :label="$t('tableText.처리시간')"
        prop="re_time" align="center" >
      </el-table-column>

        <el-table-column
        label="read_time"
        prop="read_time" align="center" >
      </el-table-column>


       <el-table-column
        label="마지막입금"
        prop="last_money_date" align="center" >
      </el-table-column>

		   <el-table-column
		   align="center"
			prop="status"
			:label="$t('tableText.처리상태')"
		 >
			<template slot-scope="scope">
            	<el-button type="text" @click="openModel(scope.row.id)"><span :class="colorObj[scope.row.status]">{{valObj[scope.row.status]}}</span></el-button>
        	</template>
		  </el-table-column>

		
		
		  
	
		 
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
			
				
				
</div>
 </template>

 <script>
 	import qaDialog from '../../components/common/qa-dialog.vue';
 import layer from '../../components/common/layer.vue';
import layerNew from '../../components/common/layer-new.vue';
    export default {
       components: {
      layer,layerNew,qaDialog
    },
    	data(){
    		return{
    			dwidth:'900px',
    			otp:'',
    			 level_title:{
             '-2':this.$i18n.t("msg.블랙"),
              '-1':this.$i18n.t("msg.대기"),
              '0':this.$i18n.t("msg.기본")              
            },
    			domain:window.sessionStorage.getItem('domain'),
    			 sitetype:window.sessionStorage.getItem('sitetype'),
    			 bg:window.sessionStorage.getItem('bg'),
    			 userid:window.sessionStorage.getItem('userid'),
    			 aid:window.sessionStorage.getItem('admin_id'),
    			  multi_site:window.sessionStorage.getItem('multi_site'),
    			formLoading:false,
         		 idDialogVisible: false,
    			  qa:[],
    			   colorObj:{
			        '0':'text-danger',
			        '1':'text-primary',
			        '2':'text-success',
			       
			       
			      },
    			  valObj:{
			       '0':this.$i18n.t("msg.대기"),
			        '1':this.$i18n.t("msg.완료"),
			        '2':this.$i18n.t("msg.보류"),
			       
			       
			      },
    			searchform:{
    				keyword:'',
    				time:[],
    				hide_del:false,
    				searchOptions:[
                
    				{
		        	label:this.$i18n.t("msg.아이디"),
		        	value:'user_id'
		        },
		        
		       

		        ],
		        searchOptions2:[
                
    					{
		        	label:this.$i18n.t("msg.전체"),
		        	value:''
		        },{
		        	label:this.$i18n.t("msg.대기"),
		        	value:'0'
		        },
		        
		        {
		        	label:this.$i18n.t("msg.보류"),
		        	value:'2'
		        },
		        {
		        	label:this.$i18n.t("msg.완료"),
		        	value:'1'
		        },
		      
		        ],
		        value:'',
		        value2:'',


    			},
    			 pickerOptions: {
    			},
          shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        
    
    			
		        
    		
    			total:0,
    			size:0,
    			loading: false,
    			 editIndex:-1,
    			 creatModel:false,
    			 tableData: [],
    			
			          currentPage:1,
			          multipleSelection:[],
			          superSearch:false,
			          form:{
			          	id:'',
			          	user_title:'',
			          	user_id:'',
			          	user_contents:'',
			          	add_time:'',
			          	admin_contents:'',
			          	admin_title:'',
			          	mem_name:'',
			          	re_time:'',
			          	status:''
					
						
			          },
			           rules: {
				          username: [
				            { required: true, message:this.$i18n.t("msg.입력해주세요"), trigger: 'blur' },
				           
				          ],
				           phone: [
				            { required: true, message:this.$i18n.t("msg.입력해주세요"), trigger: 'blur' },
				          
				          ],
				            address: [
				            { required: true, message:this.$i18n.t("msg.입력해주세요"), trigger: 'blur' },
				           
				          ],
				          
				           total_price: [
				            { required: true, message:this.$i18n.t("msg.입력해주세요"), trigger: 'blur' },
				          
				          ],

      }
    			}
    			
    			
    		},
    		created() {
    			

    			this.getList();
    			
			
		},
    	
    	methods:{
    		   // 关闭弹框（头部的X）
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
    		openIdModel(id){
    			 let pix=window.screen.width;
           
                let width='1080px';
                if(pix<1200)
                {
                  width='95%';
                }

    			if(this.aid=='soft10')
           {
                this.$layer.iframe({
                type: 2,
                title: id,
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    layerid:'id'
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                 area: [width+'', '700px'],
             
             });
              return;
           }
            let layerwidth='950px';
                if(pix<1200)
                {
                  layerwidth='95%';
                }
    		  this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: [layerwidth+'', '680px'],
         
        });

    		},
    			 // 搜索事件
			searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                	this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                	 return;
                }

              this.currentPage=1;
            


    			this.getList();
    			
             

    		},
		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			     
    		getList(){

    		

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let hide_del=this.searchform.hide_del ? '1' : '0';
    			 let urls=this.domain+'/admin/qalist?status='+this.searchform.value2+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage+'&hide_del='+hide_del;
    			
    			// if(bm!='')
    			// {
       //            urls=urls+'&search=service_no%3A'+bm+'%3Bphone%3A'+bm+'%3Btoken%3A'+bm+'%3Bmac%3A'+bm;
    			// }
             
    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                    
                     this.tableData =response.data.data.data
                     this.total = response.data.data.total
                     this.currentPage = response.data.data.current_page
                     this.size =response.data.data.per_page
                     this.loading =false
               
            }).catch((error) =>{
            	
                 this.$message.error(error);
              this.loading = false
               
            })
    		},
    		openModel(id){

    			 this.$layer.iframe({
		            type: 2,
		            title: '편집',
		            content: {
		                content: qaDialog,
		                parent: this,
		                data:{
		                info:{id:id},
		                layerid:'id'
		                }
		              
		            },
		            shadeClose: false,
		             maxmin : true,

		            shade: false,
		            area: ['940px', '570px'],
		           
		        });
		    			
    		},
    		
    		
    		handleSelectionChange(val) {
    			//console.log(val)
                this.multipleSelection = val;

      },
    	  // 批量删除
			deleteAll(){
				this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
					confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
					type: 'warning'
				}).then(() => {
					let token=window.sessionStorage.getItem('user');

					//console.log('hh',this.multipleSelection);

                    let newids=[];

					 this.multipleSelection.forEach(item=>{
					 	
					 	//console.log('id',item.idx);
					 	newids.push(item.id);
					 });

					 console.log('newids',newids);

					this.$axios({
			                method:'post',
			                 data:{idx:newids,opt:this.otp},
			                url:this.domain+'/admin/qa_del',
			                'Accept': 'application/json',
			                headers: { 'Authorization': 'Bearer ' + token },
			                
			               
			            }).then((response) =>{ 
			            	
			            	if(response.data.code==200){
			            		this.$message({
					    				message:response.data.msg,
					    				type:'success'
			    					})
			            	}else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
			            	this.getList()
    
			            }).catch((error) =>{
			                console.log(error)       //请求失败返回的数据
			            })
           				
       

    			})

				
			}, 	
			restoreAll(){
				this.$confirm('선택한 삭제건을 복구하시겠습니까?', this.$i18n.t("msg.알림"), {
					confirmButtonText: '복구',
          cancelButtonText: this.$i18n.t("msg.취소"),
					type: 'warning'
				}).then(() => {
					let token=window.sessionStorage.getItem('user');
                    let newids=[];

					 this.multipleSelection.forEach(item=>{
					 	newids.push(item.id);
					 });

					this.$axios({
			                method:'post',
			                 data:{idx:newids,opt:this.otp},
			                url:this.domain+'/admin/qa_restore',
			                'Accept': 'application/json',
			                headers: { 'Authorization': 'Bearer ' + token },
			            }).then((response) =>{ 
			            	if(response.data.code==200){
			            		this.$message({
					    				message:response.data.msg,
					    				type:'success'
			    					})
			            	}else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
			            	this.getList()
			            }).catch((error) =>{
			                console.log(error)
			            })
    			})
			}, 	
    	
    		
    	}
  }
</script>

 <style scoped>
 .bg-danger{
 	background-color:#72e8ff!important
 }
.bg-primary{
	background-color:#acc4dd!important
}
.bg-yellow {
    background-color: #dc8e35!important;
}
/deep/ .el-select-dropdown__item.selected{
	color:#000
}
/deep/ .el-input__inner{
	background:transparent;
	border:1px solid #cfcfcf;
	border-radius:2px;
}
/deep/ .el-dialog__body{
	padding:10px;
}
/deep/ .el-form-item {
	margin-bottom:10px;
}
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 .mem-id-cell {
  min-height: 30px;
  padding: 4px 0;
 }

 .qa-del-text {
  color: #c0392b;
  font-weight: 600;
 }


</style>



// WEBPACK FOOTER //
// src/views/qa/list.vue